import { render, staticRenderFns } from "./DefaultSummary.vue?vue&type=template&id=02c95e30&"
import script from "./DefaultSummary.vue?vue&type=script&lang=ts&"
export * from "./DefaultSummary.vue?vue&type=script&lang=ts&"
import style0 from "./DefaultSummary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports